import { isAmerican, isMexican, Nationality } from './nationality';

export type INAMICountryId = number;

export enum INAMICountry {
  USA = 57,
  Mexico = 115,
}

export const getINAMICountryOfBirthByNationality = (nationality: Nationality | null): INAMICountryId | null => {
  /**
   * There is no nationality.
   */
  if (!nationality) return null;

  if (isAmerican(nationality)) return INAMICountry.USA;

  if (isMexican(nationality)) return INAMICountry.Mexico;

  /**
   * The nationality is Nationality.Other (Non-American and Non-Mexican).
   *
   * Return `null` because there is no linked INAMICountry to
   * Nationality.Other.
   */
  return null;
};
